import type { ReactNode } from 'react';
import { Modal } from '@mantine/core';
import '@/styles/flows.css';

interface Props {
  opened: boolean;
  onClose: () => void;
  /** A plain question ("Cancel this lift?"). */
  title: ReactNode;
  children: ReactNode;
}

/**
 * Confirmation for an action that tells other people something or can't be undone. A bottom
 * sheet on phones (thumb reach), a centred dialog on wider screens.
 */
export function ConfirmSheet({ opened, onClose, title, children }: Props) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={title}
      classNames={{ inner: 'rides-sheet-inner', content: 'rides-sheet-content', title: 'rides-sheet-title' }}
      transitionProps={{ transition: 'slide-up', duration: 160 }}
    >
      {children}
    </Modal>
  );
}
